import { RcFile } from 'antd/es/upload'
import axios from 'axios'

export const ACCEPT_TYPES_UPLOAD_FILE = [
  'text/csv',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel'
]

const IMAGE_MAX_WIDTH = 600
const IMAGE_MAX_HEIGHT = 600

export const isValidPhotoSize = (width: number, height: number) => {
  return width <= IMAGE_MAX_WIDTH && height <= IMAGE_MAX_HEIGHT
}

export const validatePhoto = (file: RcFile): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    const objectUrl = URL.createObjectURL(file)

    img.onload = () => {
      const { width, height } = img

      if (!isValidPhotoSize(width, height)) {
        reject('image_too_large')
      }

      resolve(objectUrl)
    }

    img.onerror = () => {
      reject('invalid_image')
    }

    img.src = objectUrl
  })
}

export const onSubmitUploadDocument = async (
  signedUrl?: string,
  originFile?: RcFile,
  fileDataType?: string
) => {
  if (!signedUrl) return

  await axios.put(signedUrl, originFile, {
    headers: {
      'Content-Type': fileDataType ?? 'application/octet-stream'
    }
  })
}
